var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { createRef, forwardRef, useEffect, useImperativeHandle, useRef, useState, } from 'react';
import { CFTab } from './Tab';
import { CFTabsElements } from './Tabs.styles';
export const CFTabsCore = ({ alignment, alternateTheme = false, badgeConfigs, customTheme, initialSelectedTab = null, items, onSelectTab, withAnimatedBorder = true, }, ref) => {
    const tabItemsRef = useRef([]);
    const [selectedTab, setSelectedTab] = useState(initialSelectedTab || items[0].id);
    const [animatedBorderConfigs, setAnimatedBorderConfigs] = useState({
        $left: 0,
        $opacity: 0,
        $width: 0,
    });
    const { AnimatedBar, Root } = CFTabsElements;
    const setTab = (id) => {
        if (onSelectTab)
            onSelectTab({ previous: selectedTab, selected: id });
        setSelectedTab(id);
    };
    const updateAnimatedBorder = () => {
        var _a, _b, _c, _d;
        if (!withAnimatedBorder)
            return;
        const targetRef = tabItemsRef.current.find((obj) => {
            var _a;
            return ((_a = obj === null || obj === void 0 ? void 0 : obj.current) === null || _a === void 0 ? void 0 : _a.id) === selectedTab;
        });
        setAnimatedBorderConfigs({
            $left: (_b = (_a = targetRef === null || targetRef === void 0 ? void 0 : targetRef.current) === null || _a === void 0 ? void 0 : _a.left) !== null && _b !== void 0 ? _b : 0,
            $opacity: (targetRef === null || targetRef === void 0 ? void 0 : targetRef.current) ? 1 : 0,
            $width: (_d = (_c = targetRef === null || targetRef === void 0 ? void 0 : targetRef.current) === null || _c === void 0 ? void 0 : _c.width) !== null && _d !== void 0 ? _d : 0,
        });
    };
    useEffect(() => {
        updateAnimatedBorder();
    }, [selectedTab]);
    useEffect(() => {
        if (!initialSelectedTab)
            return;
        if (initialSelectedTab !== selectedTab)
            setSelectedTab(initialSelectedTab);
    }, [initialSelectedTab]);
    useEffect(() => {
        if (!withAnimatedBorder)
            return;
        const resizeListener = () => {
            updateAnimatedBorder();
        };
        window.addEventListener('resize', resizeListener);
        return () => {
            window.removeEventListener('resize', resizeListener);
        };
    }, []);
    useEffect(() => {
        const match = items.find(({ id }) => selectedTab === id);
        if (!match) {
            setSelectedTab(initialSelectedTab || items[0].id);
        }
        else {
            updateAnimatedBorder();
        }
    }, [items]);
    useImperativeHandle(ref, () => ({
        selectTab: (tabId) => setTab(tabId),
    }));
    return (React.createElement(Root, { "$alignment": alignment },
        items.map((_a, i) => {
            var { badge, id, label } = _a, rest = __rest(_a, ["badge", "id", "label"]);
            if (i === 0)
                tabItemsRef.current = [];
            const tabRef = createRef();
            tabItemsRef.current.push(tabRef);
            return (React.createElement(CFTab, Object.assign({ active: selectedTab === id, alternateTheme: alternateTheme, badge: badge ? Object.assign(Object.assign({}, (badgeConfigs !== null && badgeConfigs !== void 0 ? badgeConfigs : {})), (badge !== null && badge !== void 0 ? badge : {})) : undefined, customTheme: customTheme, id: id, key: id, label: label }, rest, { onClick: () => setTab(id), ref: tabRef, withActiveBorder: !withAnimatedBorder })));
        }),
        withAnimatedBorder && (React.createElement(AnimatedBar, Object.assign({ "$alternateTheme": alternateTheme, "$customTheme": customTheme }, animatedBorderConfigs)))));
};
export const CFTabs = forwardRef(CFTabsCore);
